module.exports = __webpack_public_path__ + "media/bootstrap-icons/piggy-bank-8e0168f9.svg";